(function () {
  const COUNTRY_PREFIX_MAP = {
    France: '+33',
    'United States': '+1',
    'United Kingdom': '+44',
    Italy: '+39',
    Spain: '+34',
    Germany: '+49',
    'United Arab Emirates': '+971',
    China: '+86',
    Japan: '+81',
    'South Korea': '+82',
  };

  function updateSelectPlaceholderState(select) {
    if (!select) return;
    select.classList.toggle('appointment-vaillant__input--placeholder', !select.value);
  }

  function syncPrefixFromCountry(countrySelect, prefixSelect) {
    const selectedOption = countrySelect.selectedOptions[0];
    const prefix = selectedOption?.dataset.phonePrefix || COUNTRY_PREFIX_MAP[countrySelect.value];

    if (!prefix) return;

    const matchingOption = [...prefixSelect.options].find((option) => option.value === prefix);
    if (matchingOption) prefixSelect.value = prefix;
  }

  function initAppointmentForm() {
    const form = document.getElementById('AppointmentFormVaillant');
    if (!form || form.dataset.appointmentInit === 'true') return;

    form.dataset.appointmentInit = 'true';

    const countrySelect = document.getElementById('AppointmentFormVaillant-country');
    const prefixSelect = document.getElementById('AppointmentFormVaillant-prefix');

    if (countrySelect && prefixSelect) {
      countrySelect.addEventListener('change', () => {
        syncPrefixFromCountry(countrySelect, prefixSelect);
        updateSelectPlaceholderState(countrySelect);
      });
      updateSelectPlaceholderState(countrySelect);
    }

    form.querySelectorAll('.appointment-vaillant__select select').forEach((select) => {
      updateSelectPlaceholderState(select);
      select.addEventListener('change', () => updateSelectPlaceholderState(select));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppointmentForm);
  } else {
    initAppointmentForm();
  }
})();
